import script from "./push-active-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./push-active-modal.vue?vue&type=script&lang=ts&setup=true"

import "./push-active-modal.scss?vue&type=style&index=0&id=659c0448&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659c0448"]])

export default __exports__